/* ============================================================
   REVAL — Shopify Theme JavaScript
   Handles: header, cart drawer, add-to-cart, parallax,
            hero particles, scroll reveal, PDP scent canvas,
            tabs, qty, gallery, cart page AJAX
   ============================================================ */

'use strict';

// ── Static product data (mirrors app/data/products.js) ───────
const REVAL_PRODUCTS = {
  'athar-edp': {

    nameTranslit: 'Athar',
    scentProfile: 'Floral · Fresh · Luminous',
    inspiredBy: 'Flora Gorgeous Gardenia by Gucci',
    description: 'أثر — a trace left behind, a presence felt long after departure. Pear blossom and red berries open bright over Italian mandarin, blooming into a heart of gardenia, jasmine and frangipani. Brown sugar and patchouli anchor it all, leaving an invisible impression on everything it touches.',
    howToUse: 'Apply to pulse points — wrists, neck, inner elbows. Layer lightly for a daytime presence or build for an evening statement. The patchouli base evolves uniquely with your skin chemistry.',
    ingredients: 'Alcohol Denat., Parfum (Fragrance), Aqua (Water), Benzyl Benzoate, Linalool, Citronellol, Geraniol, Coumarin, Eugenol, Benzyl Salicylate.',
    scentNotes: { top: ['Pear Blossom', 'Red Berries', 'Italian Mandarin'], heart: ['Gardenia', 'Jasmine', 'Frangipani'], base: ['Brown Sugar', 'Patchouli'] },
    scentTheme: 'floral',
    bgColors: ['#1a0820', '#2d0a3a', '#0d0612'],
    particleColors: ['#ffb3d9', '#e8a0c0', '#ffd6eb', 'rgba(255,200,230,0.4)'],
  },
  'jadal-edp': {

    nameTranslit: 'Jadal',
    scentProfile: 'Warm · Sweet · Addictive',
    inspiredBy: 'Milkshake by Ganache',
    description: 'جدل — debate, tension, an irresistible pull. A rich opening of caramel, sweet milk and vanilla draws you close before a heart of ice cream, whipped cream and malt settles beneath. Vanilla, musk and sandalwood close it out — simultaneously comforting and provocative.',
    howToUse: 'Perfect for close-contact moments. Apply to the chest and neck. Warm skin activates the caramel and vanilla top, making it richer throughout the day.',
    ingredients: 'Alcohol Denat., Parfum (Fragrance), Aqua (Water), Coumarin, Benzyl Benzoate, Linalool, Limonene, Vanillin, Benzyl Alcohol.',
    scentNotes: { top: ['Caramel', 'Sweet Milk', 'Vanilla'], heart: ['Ice Cream', 'Whipped Cream', 'Malt'], base: ['Vanilla', 'Musk', 'Sandalwood'] },
    scentTheme: 'warm_sweet',
    bgColors: ['#1a0e00', '#2a1400', '#140a00'],
    particleColors: ['#d4820a', '#c8a050', '#e8c880', 'rgba(200,140,60,0.45)'],
  },
  'atmah-edp': {

    nameTranslit: 'Atmah',
    scentProfile: 'Dark · Woody · Intense',
    inspiredBy: 'Le Male Elixir by Jean Paul Gaultier',
    description: 'عتمة — darkness, the hour before dawn. An opulent opening of lavender and mint gives way to benzoin and vanilla at the heart. Honey, tonka bean and tobacco form the foundation, creating a brooding, magnetic presence that commands every room it enters.',
    howToUse: 'Best worn as an evening or night fragrance. Apply generously to the chest and wrists. The tobacco base is long-lasting — a little goes a long way.',
    ingredients: 'Alcohol Denat., Parfum (Fragrance), Aqua (Water), Linalool, Coumarin, Benzyl Benzoate, Vanillin, Eugenol, Benzyl Alcohol.',
    scentNotes: { top: ['Lavender', 'Mint'], heart: ['Benzoin', 'Vanilla'], base: ['Honey', 'Tonka Bean', 'Tobacco'] },
    scentTheme: 'dark_woody',
    bgColors: ['#0a0714', '#0d0a1a', '#080512'],
    particleColors: ['#7b4fa0', '#9b6fd0', '#4a2080', 'rgba(140,100,200,0.35)'],
  },
  'khayal-edp': {
    nameTranslit: 'Khayal',
    scentProfile: 'Oriental · Opulent · Mystical',
    inspiredBy: 'Ehsas by Arabian Oud',
    description: 'خيال — imagination, a vision of something unreachable. Bergamot and lemon open crisp over a heart of rose, jasmine and white flowers, grounded in sandalwood, musk, amber and vanilla. This is luxury that transcends borders.',
    howToUse: 'Apply to pulse points and clothing for extended sillage. The citrus opens boldly — allow 20 minutes for the full floral heart to bloom.',
    ingredients: 'Alcohol Denat., Parfum (Fragrance), Aqua (Water), Safranal, Agarwood Oil, Santalum Album Oil, Benzyl Benzoate, Eugenol, Isoeugenol.',
    scentNotes: { top: ['Bergamot', 'Lemon'], heart: ['Rose', 'Jasmine', 'White Flowers'], base: ['Sandalwood', 'Musk', 'Amber', 'Vanilla'] },
    scentTheme: 'oriental',
    bgColors: ['#1a1000', '#1e1200', '#140d00'],
    particleColors: ['#d4a017', '#c8860a', '#e8c040', 'rgba(210,160,20,0.4)'],
  },
  'thawra-edp': {

    nameTranslit: 'Thawrah',
    scentProfile: 'Tropical · Smoky · Bold',
    inspiredBy: 'Oud Maracujá by Maison Crivelli',
    description: 'ثورة — revolution. An explosive contrast: passionfruit, saffron and Turkish rose ignite above a heart of oud, Indonesian patchouli and benzoin. Leather, amber, vanilla and akigalawood close the story. Tropical meets ancient, light meets shadow.',
    howToUse: 'A statement fragrance — wear boldly. Apply to the neck and wrists. The passionfruit opens bright before the oud and leather base takes over within the hour.',
    ingredients: 'Alcohol Denat., Parfum (Fragrance), Aqua (Water), Limonene, Linalool, Citral, Agarwood Oil, Benzyl Benzoate, Coumarin.',
    scentNotes: { top: ['Passionfruit', 'Saffron', 'Turkish Rose'], heart: ['Oud', 'Indonesian Patchouli', 'Benzoin'], base: ['Leather', 'Amber', 'Vanilla', 'Akigalawood'] },
    scentTheme: 'tropical_smoky',
    bgColors: ['#200800', '#1a0500', '#280a00'],
    particleColors: ['#ff6b35', '#e8400a', '#ffa07a', 'rgba(255,100,50,0.4)'],
  },
  obsidian: {
    nameTranslit: 'Obsidian',
    scentProfile: 'Amber · Warm · Velvet',
    inspiredBy: 'Stronger With You Amber by Giorgio Armani',
    description: 'OBSIDIAN. Named for volcanic glass — formed under extreme pressure, impossibly smooth to the touch. A single sweep of lavender opens into a pure amber heart, softened by vanilla and roasted chestnut. Minimal, powerful, unforgettable.',
    howToUse: 'A daytime-to-evening fragrance. Apply to the wrists and chest. The amber heart evolves over hours — richest in the late afternoon heat.',
    ingredients: 'Alcohol Denat., Parfum (Fragrance), Aqua (Water), Vanillin, Coumarin, Benzyl Benzoate, Eugenol, Cinnamyl Alcohol, Isoeugenol.',
    scentNotes: { top: ['Lavender'], heart: ['Amber'], base: ['Vanilla', 'Chestnut'] },
    scentTheme: 'warm_spice',
    bgColors: ['#180800', '#1c0900', '#1a0600'],
    particleColors: ['#c8600a', '#e8800a', '#d4440a', 'rgba(200,100,20,0.5)'],
  },
  dolce: {
    nameTranslit: 'Dolce',
    scentProfile: 'Floral · Warm · Feminine',
    inspiredBy: 'Libre Le Parfum by YSL',
    description: 'DOLCE — Italian for sweet, for softness, for belonging. Ginger, saffron, mandarin orange and bergamot open with a warm luminosity, revealing orange blossom and lavender at the heart. Honey, vanilla, tonka bean and vetiver create a skin-like base that feels like your most confident self.',
    howToUse: 'A versatile, all-day fragrance. Apply generously — the tonka base hugs the skin and builds throughout the day. Reapply at the wrists for evening.',
    ingredients: 'Alcohol Denat., Parfum (Fragrance), Aqua (Water), Linalool, Benzyl Benzoate, Citral, Geraniol, Eugenol, Coumarin, Vanillin.',
    scentNotes: { top: ['Ginger', 'Saffron', 'Mandarin Orange', 'Bergamot'], heart: ['Orange Blossom', 'Lavender'], base: ['Honey', 'Vanilla', 'Tonka Bean', 'Vetiver'] },
    scentTheme: 'fresh_floral',
    bgColors: ['#0e0818', '#120a1e', '#0a0612'],
    particleColors: ['#c8a0e8', '#9060c0', '#e8c0f8', 'rgba(200,160,240,0.35)'],
  },
  cipher: {
    nameTranslit: 'Cipher',
    scentProfile: 'Woody · Spiced · Masculine',
    inspiredBy: 'Dior Homme (2020) by Dior',
    description: 'CIPHER. An unbreakable code. Bergamot, pink pepper and elemi open sharp and bright, settling into a heart of atlas cedar, cashmere wood and patchouli. Iso E Super, Haitian vetiver and white musk seal the message. Quiet confidence, absolute distinction.',
    howToUse: 'Apply to pulse points for a close, intimate projection. Best worn in cool weather or air-conditioned environments where the woods can fully develop.',
    ingredients: 'Alcohol Denat., Parfum (Fragrance), Aqua (Water), Irone (Iris), Vetiverol, Benzyl Benzoate, Linalool, Cinnamyl Alcohol, Coumarin.',
    scentNotes: { top: ['Bergamot', 'Pink Pepper', 'Elemi'], heart: ['Atlas Cedar', 'Cashmere Wood', 'Patchouli'], base: ['Iso E Super', 'Haitian Vetiver', 'White Musk'] },
    scentTheme: 'dark_powdery',
    bgColors: ['#080a06', '#0a0c08', '#060804'],
    particleColors: ['#6b8060', '#5a7050', '#8a9870', 'rgba(100,120,80,0.4)'],
  },
  levant: {
    nameTranslit: 'Levant',
    scentProfile: 'Deep Oriental · Rich · Intoxicating',
    inspiredBy: 'Khamrah by Lattafa',
    description: 'LEVANT. Named for the ancient lands where east meets west — the birthplace of scent culture. Cinnamon, nutmeg and bergamot open into a heart of dates, praline, tuberose and mahonial, settling into vanilla, tonka bean, amberwood, myrrh, benzoin and akigalawood. This is heritage in a bottle.',
    howToUse: 'Apply to warm pulse points and allow to dry down fully. LEVANT is best experienced when given time — the spice and resin transform over 2–3 hours into something remarkable.',
    ingredients: 'Alcohol Denat., Parfum (Fragrance), Aqua (Water), Agarwood Oil, Benzyl Benzoate, Vanillin, Eugenol, Coumarin, Isoeugenol, Cinnamyl Alcohol.',
    scentNotes: { top: ['Cinnamon', 'Nutmeg', 'Bergamot'], heart: ['Dates', 'Praline', 'Tuberose', 'Mahonial'], base: ['Vanilla', 'Tonka Bean', 'Amberwood', 'Myrrh', 'Benzoin', 'Akigalawood'] },
    scentTheme: 'deep_oriental',
    bgColors: ['#150005', '#1a0008', '#100004'],
    particleColors: ['#8b0020', '#c41e3a', '#d4a017', 'rgba(200,20,50,0.4)'],
  },
  'black-suit': {
    nameTranslit: 'Black Suit',
    scentProfile: 'Spicy · Woody · Refined',
    inspiredBy: 'The One EDP by Dolce & Gabbana',
    description: 'A crisp opening of grapefruit, coriander and basil melts into warm cardamom, ginger and orange blossom, before settling on smooth cedar and soft amber wrapped in tobacco. Black Suit is quiet confidence in its finest form — tailored for evenings where elegance speaks louder than words.',
    howToUse: 'Apply to the chest and wrists for an evening presence. The tobacco and cedar base deepens over the first hour — ideal for tailored, formal occasions.',
    ingredients: 'Alcohol Denat., Parfum (Fragrance), Aqua (Water), Limonene, Linalool, Coumarin, Benzyl Benzoate, Citral, Eugenol.',
    scentNotes: { top: ['Grapefruit', 'Coriander', 'Basil'], heart: ['Cardamom', 'Ginger', 'Orange Blossom'], base: ['Amber', 'Tobacco', 'Cedar'] },
    scentTheme: 'warm_spice',
    bgColors: ['#140d05', '#1c1206', '#0d0803'],
    particleColors: ['#c9924a', '#a5723a', '#e0b878', 'rgba(200,150,80,0.4)'],
  },
  'tropica-melodia': {
    nameTranslit: 'Tropica Melodia',
    scentProfile: 'Citrus · Fruity · Musky',
    inspiredBy: 'Erba Pura by Xerjoff',
    description: 'Sicilian orange, Calabrian bergamot and Sicilian lemon open into a lush fruity heart, settling into white musk, Madagascar vanilla and amber. Sunlit fruits meet a silky white musk, creating a scent that feels weightless yet unforgettable — bright, addictive, and effortlessly luxurious.',
    howToUse: 'A daytime signature — apply generously to pulse points. The citrus opens vivid and the musk base builds softly through the afternoon.',
    ingredients: 'Alcohol Denat., Parfum (Fragrance), Aqua (Water), Limonene, Citral, Linalool, Benzyl Benzoate, Vanillin, Coumarin.',
    scentNotes: { top: ['Sicilian Orange', 'Calabrian Bergamot', 'Sicilian Lemon'], heart: ['Fruity Notes'], base: ['White Musk', 'Madagascar Vanilla', 'Amber'] },
    scentTheme: 'warm_sweet',
    bgColors: ['#1c1400', '#241a00', '#120d00'],
    particleColors: ['#f0b429', '#e89838', '#ffd580', 'rgba(240,180,40,0.4)'],
  },
  dahab: {
    nameTranslit: 'Dahab',
    scentProfile: 'Citrus · Amber · Golden',
    inspiredBy: 'Symphony by Louis Vuitton',
    description: 'Bright bergamot shines over a heart of ginger, creating an opening that\'s fresh, luminous and full of life. As it settles, a soft golden warmth of ambrox emerges, leaving a sophisticated trail that feels both energetic and refined. Dahab — Arabic for gold.',
    howToUse: 'A minimalist, all-season fragrance. Apply to the wrists and neck — the ambrox base carries the scent close to the skin for hours.',
    ingredients: 'Alcohol Denat., Parfum (Fragrance), Aqua (Water), Limonene, Linalool, Benzyl Benzoate, Coumarin.',
    scentNotes: { top: ['Bergamot'], heart: ['Ginger'], base: ['Ambrox'] },
    scentTheme: 'oriental',
    bgColors: ['#1a1200', '#221800', '#100b00'],
    particleColors: ['#d4a017', '#c8860a', '#e8c040', 'rgba(210,160,20,0.4)'],
  },
  'imperial-gold-edp': {
    nameTranslit: 'Imperial Gold',
    scentProfile: 'Fruity · Chypre · Bold',
    inspiredBy: 'Aventus by Creed',
    description: 'Crisp pineapple, bergamot, black currant and apple open into a heart of birch, patchouli, Moroccan jasmine and rose, settling into musk, oakmoss, ambergris and vanilla. Imperial Gold is bold sophistication — a signature scent for those who lead.',
    howToUse: 'Apply to pulse points and clothing for maximum longevity. The birch and oakmoss base develops richly over several hours — best for evening or formal wear.',
    ingredients: 'Alcohol Denat., Parfum (Fragrance), Aqua (Water), Limonene, Linalool, Citral, Benzyl Benzoate, Coumarin, Geraniol, Eugenol.',
    scentNotes: { top: ['Pineapple', 'Bergamot', 'Black Currant', 'Apple'], heart: ['Birch', 'Patchouli', 'Moroccan Jasmine', 'Rose'], base: ['Musk', 'Oakmoss', 'Ambergris', 'Vanilla'] },
    scentTheme: 'tropical_smoky',
    bgColors: ['#1c1400', '#241a05', '#140e00'],
    particleColors: ['#e0b23c', '#c9924a', '#f0d080', 'rgba(220,180,60,0.4)'],
  },
  'citrus-pulse-edp': {

    nameTranslit: 'Citrus Pulse',
    scentProfile: 'Citrus · Tea · Woody',
    inspiredBy: 'Imagination by Louis Vuitton',
    description: 'Sparkling citron, Calabrian bergamot and Sicilian orange dance with delicate Tunisian neroli, Nigerian ginger and Ceylon cinnamon, before Chinese black tea, ambrox, olibanum and guaiac wood bring effortless balance. Fresh yet sophisticated, Citrus Pulse captures the feeling of endless possibilities.',
    howToUse: 'Apply generously to pulse points — the citrus and tea accord is versatile enough for day or evening wear. Best in warm weather.',
    ingredients: 'Alcohol Denat., Parfum (Fragrance), Aqua (Water), Limonene, Citral, Linalool, Benzyl Benzoate, Coumarin, Cinnamyl Alcohol.',
    scentNotes: { top: ['Citron', 'Calabrian Bergamot', 'Sicilian Orange'], heart: ['Tunisian Neroli', 'Nigerian Ginger', 'Ceylon Cinnamon'], base: ['Chinese Black Tea', 'Ambrox', 'Olibanum', 'Guaiac Wood'] },
    scentTheme: 'dark_powdery',
    bgColors: ['#141c00', '#1c2400', '#0e1400'],
    particleColors: ['#b8c93a', '#96a82e', '#d4e070', 'rgba(180,200,60,0.4)'],
  },
  'vento-marino': {
    nameTranslit: 'Vento Marino',
    scentProfile: 'Marine · Citrus · Woody',
    inspiredBy: 'Invictus EDT by Paco Rabanne',
    description: 'Fresh marine air collides with grapefruit and mandarin orange, while bay leaf and jasmine rise at the heart. Ambergris, guaiac wood, oakmoss and patchouli surface beneath, carrying the energy of the ocean with a bold spirit made to move freely.',
    howToUse: 'Apply to the chest and wrists. Vento Marino is at its best in warm, humid climates — a splash-on, all-day fresh fragrance.',
    ingredients: 'Alcohol Denat., Parfum (Fragrance), Aqua (Water), Limonene, Linalool, Benzyl Benzoate, Coumarin, Geraniol.',
    scentNotes: { top: ['Grapefruit', 'Marine Notes', 'Mandarin Orange'], heart: ['Bay Leaf', 'Jasmine'], base: ['Ambergris', 'Guaiac Wood', 'Oakmoss', 'Patchouli'] },
    scentTheme: 'dark_powdery',
    bgColors: ['#001418', '#00181c', '#000c0e'],
    particleColors: ['#00c9c9', '#00a0a0', '#5be0e0', 'rgba(0,200,200,0.4)'],
  },
  gravity: {
    nameTranslit: 'Gravity',
    scentProfile: 'Aromatic · Fruity · Woody',
    inspiredBy: 'Legend EDT by Montblanc',
    description: 'Bright lavender, pineapple, bergamot and lemon verbena settle into red apple, dried fruits, oak moss, geranium, coumarin and rose, before smooth tonka bean and sandalwood bring it home. Gravity is clean, masculine, and undeniably magnetic — the kind of presence that\'s felt before it\'s noticed.',
    howToUse: 'A versatile day-to-evening fragrance. Apply to pulse points — the tonka and sandalwood base carries a warm, magnetic trail.',
    ingredients: 'Alcohol Denat., Parfum (Fragrance), Aqua (Water), Linalool, Limonene, Coumarin, Geraniol, Benzyl Benzoate, Citral.',
    scentNotes: { top: ['Lavender', 'Pineapple', 'Bergamot', 'Lemon Verbena'], heart: ['Red Apple', 'Dried Fruits', 'Oak Moss', 'Geranium', 'Coumarin', 'Rose'], base: ['Tonka Bean', 'Sandalwood'] },
    scentTheme: 'fresh_floral',
    bgColors: ['#0e140a', '#141c0c', '#0a1006'],
    particleColors: ['#8fae5c', '#6f8e42', '#b0d080', 'rgba(140,180,90,0.4)'],
  },
  'velvet-bloom': {
    nameTranslit: 'Velvet Bloom',
    scentProfile: 'Floral · White Florals · Delicate',
    inspiredBy: 'Bloom by Gucci',
    description: 'A graceful bouquet of jasmine unfolds over a tuberose heart, resting on soft Rangoon creeper. Velvet Bloom leaves a delicate trail that feels fresh, elegant, and beautifully feminine — a study in restraint.',
    howToUse: 'Apply to pulse points for a soft, close sillage. Ideal for daytime and office wear — the white florals stay refined rather than heavy.',
    ingredients: 'Alcohol Denat., Parfum (Fragrance), Aqua (Water), Linalool, Geraniol, Benzyl Benzoate, Citronellol, Coumarin.',
    scentNotes: { top: ['Jasmine'], heart: ['Tuberose'], base: ['Rangoon Creeper'] },
    scentTheme: 'floral',
    bgColors: ['#140a18', '#1c0e20', '#0e0612'],
    particleColors: ['#d8a8d8', '#b880b8', '#f0d0f0', 'rgba(216,168,216,0.4)'],
  },
  'after-you': {
    nameTranslit: 'After You',
    scentProfile: 'Gourmand · Fruity · Musky',
    inspiredBy: 'Yara by Lattafa',
    description: 'Orchid, heliotrope and tangerine open soft, before a gourmand accord and tropical fruits take the heart. Creamy vanilla embraces soft tropical fruits and airy musk, creating a comforting sweetness that stays close to the skin — gentle at first, unforgettable in the end.',
    howToUse: 'Apply to the wrists and neck for an intimate, skin-close scent. Best for everyday wear — the musk base is soft and long-lasting.',
    ingredients: 'Alcohol Denat., Parfum (Fragrance), Aqua (Water), Linalool, Benzyl Benzoate, Vanillin, Coumarin, Citronellol.',
    scentNotes: { top: ['Orchid', 'Heliotrope', 'Tangerine'], heart: ['Gourmand Accord', 'Tropical Fruits'], base: ['Vanilla', 'Musk', 'Sandalwood'] },
    scentTheme: 'warm_sweet',
    bgColors: ['#1c1000', '#241600', '#140c00'],
    particleColors: ['#e8a852', '#c98838', '#f8c880', 'rgba(232,168,82,0.4)'],
  },
  'soft-rose': {
    nameTranslit: 'Soft Rose',
    scentProfile: 'Floral · Fruity · Amber',
    inspiredBy: 'Paradoxe by Prada',
    description: 'Pear, tangerine and bergamot open radiant, blending effortlessly with orange blossom, neroli essence, neroli and jasmine sambac before melting into bourbon vanilla, white musk, amber and benzoin. Modern, luminous, and endlessly elegant.',
    howToUse: 'A versatile floral for day or evening. Apply to pulse points — the vanilla-amber base builds gently over the first hour.',
    ingredients: 'Alcohol Denat., Parfum (Fragrance), Aqua (Water), Linalool, Citral, Geraniol, Benzyl Benzoate, Vanillin, Coumarin.',
    scentNotes: { top: ['Pear', 'Tangerine', 'Bergamot'], heart: ['Orange Blossom', 'Neroli Essence', 'Neroli', 'Jasmine Sambac'], base: ['Bourbon Vanilla', 'White Musk', 'Amber', 'Benzoin'] },
    scentTheme: 'fresh_floral',
    bgColors: ['#1a0c10', '#220e14', '#12080c'],
    particleColors: ['#e0879e', '#c06880', '#f0b0c0', 'rgba(224,135,158,0.4)'],
  },
  'kiss-in-june': {
    nameTranslit: 'Kiss In June',
    scentProfile: 'Fruity · Sweet · Amber',
    inspiredBy: 'Her Elixir by Burberry',
    description: 'Sweet strawberry and blackberry wrapped in creamy jasmine create the feeling of golden afternoons and carefree laughter. Vanilla, amber and sandalwood settle beneath — playful, romantic, and impossible to forget.',
    howToUse: 'Apply to pulse points for a sweet, romantic sillage. Best suited for daytime and warm-weather wear.',
    ingredients: 'Alcohol Denat., Parfum (Fragrance), Aqua (Water), Linalool, Benzyl Benzoate, Vanillin, Coumarin, Citronellol.',
    scentNotes: { top: ['Strawberry', 'Blackberry'], heart: ['Jasmine'], base: ['Vanilla', 'Amber', 'Sandalwood'] },
    scentTheme: 'warm_sweet',
    bgColors: ['#1c0810', '#240a14', '#14060c'],
    particleColors: ['#e05878', '#c03858', '#f08098', 'rgba(224,88,120,0.4)'],
  },
  'toxic-vanilla': {
    nameTranslit: 'Toxic Vanilla',
    scentProfile: 'Gourmand · Vanilla · Sweet',
    inspiredBy: 'Warm Vanilla Sugar by Bath & Body Works',
    description: 'Velvety vanilla and white orchid open into a heart of sugar, coconut and jasmine, enriched further by vanilla, sandalwood and musk at the base. Toxic Vanilla is irresistibly smooth with just the right touch of temptation.',
    howToUse: 'Apply generously to the wrists and neck. The vanilla-musk base builds into a warm, enveloping sweetness through the day.',
    ingredients: 'Alcohol Denat., Parfum (Fragrance), Aqua (Water), Vanillin, Coumarin, Benzyl Benzoate, Linalool, Benzyl Alcohol.',
    scentNotes: { top: ['Vanilla', 'White Orchid'], heart: ['Sugar', 'Coconut', 'Jasmine'], base: ['Vanilla', 'Sandalwood', 'Musk'] },
    scentTheme: 'warm_sweet',
    bgColors: ['#1c1006', '#24140a', '#140c04'],
    particleColors: ['#e8c078', '#c9a058', '#f8e0a8', 'rgba(232,192,120,0.4)'],
  },
};

// ── Scent canvas themes (mirrors ScentBackground.jsx THEMES) ──
const SCENT_THEMES = {
  floral:         { speed: 0.32, size: [3,  16], count: 40, blur: true  },
  warm_sweet:     { speed: 0.26, size: [5,  18], count: 30, blur: true  },
  dark_woody:     { speed: 0.20, size: [2,  12], count: 28, blur: true  },
  oriental:       { speed: 0.42, size: [2,   9], count: 50, blur: false },
  tropical_smoky: { speed: 0.36, size: [4,  14], count: 32, blur: true  },
  warm_spice:     { speed: 0.30, size: [3,  11], count: 36, blur: true  },
  fresh_floral:   { speed: 0.28, size: [4,  16], count: 32, blur: true  },
  dark_powdery:   { speed: 0.15, size: [2,   8], count: 24, blur: false },
  deep_oriental:  { speed: 0.32, size: [3,  14], count: 38, blur: true  },
};

// ── Particle class (mirrors Particle class in ScentBackground.jsx) ──
class ScentParticle {
  constructor(w, h, colors, cfg) {
    this.w = w; this.h = h; this.colors = colors; this.cfg = cfg;
    this.init();
  }
  init() {
    const { size, speed } = this.cfg;
    this.x = Math.random() * this.w;
    this.y = this.h + Math.random() * 120;
    this.r = Math.random() * (size[1] - size[0]) + size[0];
    this.color = this.colors[Math.floor(Math.random() * this.colors.length)];
    this.life = 0;
    this.maxLife = 180 + Math.random() * 160;
    this.vx = (Math.random() - 0.5) * speed * 1.5;
    this.vy = -(speed * 0.5 + Math.random() * speed);
    this.alpha = 0;
    this.targetAlpha = Math.random() * 0.55 + 0.08;
    this.swirl = (Math.random() - 0.5) * 0.008;
  }
  update() {
    this.life++;
    this.x += this.vx;
    this.y += this.vy;
    this.vx += this.swirl;
    const t = this.life / this.maxLife;
    if (t < 0.12)      this.alpha = (t / 0.12) * this.targetAlpha;
    else if (t < 0.75) this.alpha = this.targetAlpha;
    else               this.alpha = ((1 - t) / 0.25) * this.targetAlpha;
    if (this.life >= this.maxLife || this.y < -this.r) this.init();
  }
  draw(ctx) {
    ctx.save();
    ctx.globalAlpha = this.alpha;
    const g = ctx.createRadialGradient(this.x, this.y, 0, this.x, this.y, this.r);
    g.addColorStop(0, this.color);
    g.addColorStop(1, 'transparent');
    ctx.fillStyle = g;
    ctx.beginPath();
    ctx.arc(this.x, this.y, this.r, 0, Math.PI * 2);
    ctx.fill();
    ctx.restore();
  }
}

function initScentCanvas(canvas, theme, colors, bgColors) {
  const ctx = canvas.getContext('2d');
  const cfg = SCENT_THEMES[theme] || SCENT_THEMES.floral;
  let particles = [];
  let raf;

  const resize = () => {
    canvas.width  = canvas.offsetWidth  || canvas.parentElement.offsetWidth;
    canvas.height = canvas.offsetHeight || canvas.parentElement.offsetHeight;
    if (!canvas.width || !canvas.height) return;
    particles = Array.from(
      { length: cfg.count },
      () => new ScentParticle(canvas.width, canvas.height, colors, cfg)
    );
    particles.forEach((p) => {
      p.y    = Math.random() * canvas.height;
      p.life = Math.floor(Math.random() * p.maxLife * 0.7);
    });
  };

  const drawBg = () => {
    const [c1, c2, c3] = bgColors && bgColors.length >= 3
      ? bgColors
      : ['#080808', '#0f0f0f', '#0d0d0d'];
    const grad = ctx.createRadialGradient(
      canvas.width * 0.5, canvas.height * 0.6, 0,
      canvas.width * 0.5, canvas.height * 0.5, canvas.width * 0.85
    );
    grad.addColorStop(0,   c2);
    grad.addColorStop(0.5, c1);
    grad.addColorStop(1,   c3);
    ctx.fillStyle = grad;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
  };

  const tick = () => {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    drawBg();
    if (cfg.blur) {
      ctx.filter = 'blur(8px)';
      particles.forEach((p) => { p.update(); p.draw(ctx); });
      ctx.filter = 'none';
      particles.forEach((p) => {
        ctx.save();
        ctx.globalAlpha = p.alpha * 0.35;
        ctx.fillStyle   = p.color;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r * 0.25, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
      });
    } else {
      particles.forEach((p) => { p.update(); p.draw(ctx); });
    }
    raf = requestAnimationFrame(tick);
  };

  resize();
  tick();
  const ro = new ResizeObserver(resize);
  ro.observe(canvas);
  return () => { cancelAnimationFrame(raf); ro.disconnect(); };
}

// ── Hero particle canvas (warm ambient) ──────────────────────
function initHeroCanvas() {
  const canvas = document.getElementById('rv-hero-canvas');
  if (!canvas) return;
  const ctx = canvas.getContext('2d');
  let raf;
  const PARTICLES = [];
  const COUNT = 40;
  const COLORS = [
    'rgba(201,169,110,',
    'rgba(184,0,31,',
    'rgba(230,200,140,',
    'rgba(180,140,80,',
  ];

  const resize = () => {
    canvas.width  = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;
  };

  const spawn = () => ({
    x:       Math.random() * canvas.width,
    y:       canvas.height + Math.random() * 80,
    r:       Math.random() * 3 + 1,
    color:   COLORS[Math.floor(Math.random() * COLORS.length)],
    alpha:   0,
    maxAlpha: Math.random() * 0.25 + 0.04,
    vx:      (Math.random() - 0.5) * 0.5,
    vy:      -(Math.random() * 0.45 + 0.2),
    life:    0,
    maxLife: 280 + Math.random() * 180,
  });

  resize();
  for (let i = 0; i < COUNT; i++) {
    const p = spawn();
    p.y    = Math.random() * canvas.height;
    p.life = Math.floor(Math.random() * p.maxLife * 0.6);
    PARTICLES.push(p);
  }

  const tick = () => {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    for (const p of PARTICLES) {
      p.life++;
      p.x += p.vx;
      p.y += p.vy;
      const t = p.life / p.maxLife;
      if (t < 0.1)       p.alpha = (t / 0.1) * p.maxAlpha;
      else if (t < 0.8)  p.alpha = p.maxAlpha;
      else               p.alpha = ((1 - t) / 0.2) * p.maxAlpha;
      if (p.life >= p.maxLife || p.y < -10) Object.assign(p, spawn());

      ctx.save();
      ctx.filter = 'blur(3px)';
      ctx.globalAlpha = p.alpha;
      const g = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r * 4);
      g.addColorStop(0, p.color + '1)');
      g.addColorStop(1, p.color + '0)');
      ctx.fillStyle = g;
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.r * 4, 0, Math.PI * 2);
      ctx.fill();
      ctx.filter = 'none';
      ctx.restore();
    }
    raf = requestAnimationFrame(tick);
  };

  tick();
  const ro = new ResizeObserver(resize);
  ro.observe(canvas);
}

// ── Parallax hero background ──────────────────────────────────
function initParallax() {
  const bg = document.getElementById('rv-hero-bg');
  if (!bg) return;
  let ticking = false;
  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      bg.style.transform = `translateY(${window.scrollY * 0.3}px)`;
      ticking = false;
    });
  }, { passive: true });
}

// ── Header: scroll class + mobile menu ───────────────────────
function initHeader() {
  const header = document.getElementById('rv-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 40);
    }, { passive: true });
  }

  const toggle   = document.getElementById('rv-mobile-toggle');
  const mobileNav = document.getElementById('rv-mobile-nav');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', () => {
      const open = mobileNav.classList.toggle('open');
      toggle.classList.toggle('open', open);
      toggle.setAttribute('aria-expanded', String(open));
    });
    // Close on nav link click
    mobileNav.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        mobileNav.classList.remove('open');
        toggle.classList.remove('open');
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
  }
}

// ── Scroll reveal ─────────────────────────────────────────────
function initScrollReveal() {
  const els = document.querySelectorAll('.rv-animate');
  if (!els.length) return;
  const io = new IntersectionObserver(
    (entries) => entries.forEach((e) => {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        io.unobserve(e.target);
      }
    }),
    { threshold: 0.1, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach((el) => io.observe(el));
}

// ── Toast notification ────────────────────────────────────────
function showToast(msg) {
  const toast = document.getElementById('rv-toast');
  if (!toast) return;
  toast.textContent = msg;
  toast.classList.add('visible');
  setTimeout(() => toast.classList.remove('visible'), 2500);
}

// ── Cart helpers ──────────────────────────────────────────────
function formatMoney(cents) {
  const amount = (cents / 100).toLocaleString('en-EG', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
  return `EGP ${amount}`;
}

async function fetchCart() {
  const res = await fetch('/cart.js');
  return res.json();
}

async function cartChange(key, quantity) {
  const res = await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity }),
  });
  return res.json();
}

async function cartAdd(variantId, quantity) {
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: Number(variantId), quantity }),
  });
  if (!res.ok) throw new Error('Add to cart failed');
  return res.json();
}

// ── Cart drawer ───────────────────────────────────────────────
function openDrawer() {
  const backdrop = document.getElementById('rv-drawer-backdrop');
  const drawer   = document.getElementById('rv-drawer');
  if (backdrop) backdrop.style.display = 'block';
  if (drawer) {
    drawer.style.transform  = 'translateX(0)';
    drawer.style.animation  = 'slideDrawer 0.35s var(--ease-sharp)';
  }
  refreshDrawer();
}

function closeDrawer() {
  const backdrop = document.getElementById('rv-drawer-backdrop');
  const drawer   = document.getElementById('rv-drawer');
  if (backdrop) backdrop.style.display = 'none';
  if (drawer)   drawer.style.transform = 'translateX(100%)';
}

async function refreshDrawer() {
  const cart   = await fetchCart();
  const body   = document.getElementById('rv-drawer-body');
  const footer = document.getElementById('rv-drawer-footer');
  const total  = document.getElementById('rv-drawer-total');

  // Update badge counts
  [
    document.getElementById('rv-cart-count'),
    document.getElementById('rv-cart-count-mobile'),
  ].forEach((el) => {
    if (!el) return;
    if (cart.item_count > 0) {
      el.textContent    = cart.item_count;
      el.style.display  = 'flex';
    } else {
      el.style.display  = 'none';
    }
  });

  if (!body) return;

  if (cart.item_count === 0) {
    body.innerHTML = `
      <div class="rv-drawer-empty">
        <p>Your cart is empty</p>
        <a href="/collections/all" class="rv-btn rv-btn-ghost" style="font-size:10px;margin-top:12px">Explore the Collection</a>
      </div>`;
    if (footer) footer.style.display = 'none';
  } else {
    body.innerHTML = cart.items.map((item) => `
      <div class="rv-drawer-item">
        <img src="${item.image}" alt="${item.product_title}" class="rv-drawer-item-img" loading="lazy">
        <div>
          <p class="rv-drawer-item-name">${item.product_title}</p>
          <p class="rv-drawer-item-sub">Qty: ${item.quantity} · 50 ML</p>
          <button class="rv-cart-remove" data-remove-key="${item.key}" style="margin-top:6px">Remove</button>
        </div>
        <p class="rv-drawer-item-price">${formatMoney(item.line_price)}</p>
      </div>`).join('');

    body.querySelectorAll('[data-remove-key]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        await cartChange(btn.dataset.removeKey, 0);
        refreshDrawer();
      });
    });

    if (footer) footer.style.display = 'block';
    if (total)  total.textContent    = formatMoney(cart.total_price);
  }
}

function initCartDrawer() {
  document.getElementById('rv-cart-open')?.addEventListener('click', openDrawer);
  document.getElementById('rv-cart-open-mobile')?.addEventListener('click', () => {
    document.getElementById('rv-mobile-nav')?.classList.remove('open');
    document.getElementById('rv-mobile-toggle')?.classList.remove('open');
    openDrawer();
  });
  document.getElementById('rv-drawer-close')?.addEventListener('click', closeDrawer);
  document.getElementById('rv-drawer-backdrop')?.addEventListener('click', closeDrawer);
  // Initial badge count
  refreshDrawer();
}

// ── Add to cart — card buttons (event delegation) ─────────────
function initCardATC() {
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-atc]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const variantId = btn.dataset.productId;
    if (!variantId) return;
    btn.textContent = '...';
    try {
      await cartAdd(variantId, 1);
      btn.textContent = 'Added!';
      refreshDrawer();
      showToast('Added to cart');
      setTimeout(() => { btn.textContent = 'Add to Cart'; }, 1500);
    } catch {
      btn.textContent = 'Add to Cart';
    }
  });
}

// ── Scent profile + translit + spirit-of + notes fill-in on cards ──
function initCardMeta() {
  document.querySelectorAll('[data-scent-profile]').forEach((el) => {
    const data = REVAL_PRODUCTS[el.dataset.scentProfile];
    if (data?.scentProfile) el.textContent = data.scentProfile;
  });
  document.querySelectorAll('[data-translit]').forEach((el) => {
    const data = REVAL_PRODUCTS[el.dataset.translit];
    if (data?.nameTranslit) el.textContent = data.nameTranslit;
  });

  document.querySelectorAll('[data-spirit]').forEach((el) => {
    const data = REVAL_PRODUCTS[el.dataset.spirit];
    if (data?.inspiredBy) {
      el.querySelector('span').textContent = data.inspiredBy;
      el.hidden = false;
    }
  });

  document.querySelectorAll('[data-notes]').forEach((el) => {
    const data = REVAL_PRODUCTS[el.dataset.notes];
    const notes = data?.scentNotes;
    if (!notes) return;

    const rows = [
      { label: 'Top',   notes: notes.top   },
      { label: 'Heart', notes: notes.heart },
      { label: 'Base',  notes: notes.base  },
    ].filter((r) => r.notes && r.notes.length);
    if (!rows.length) return;

    el.innerHTML = rows.map(({ label, notes }) => `
      <div class="rv-card-notes-row">
        <span class="rv-card-notes-label">${label}</span>
        <span class="rv-card-notes-value">${notes.join(', ')}</span>
      </div>`).join('');

    const card = el.closest('.rv-card');
    const toggle = card?.querySelector('[data-notes-toggle]');
    if (toggle) toggle.hidden = false;
  });
}

// ── Notes accordion toggle (event delegation) ──────────────────
function initCardNotes() {
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-notes-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const card = btn.closest('.rv-card');
    const panel = card?.querySelector('[data-notes-panel]');
    if (!panel) return;
    const open = panel.dataset.open !== 'true';
    panel.dataset.open = String(open);
    btn.setAttribute('aria-expanded', String(open));
  });
}

// ── Product Detail Page ───────────────────────────────────────
function initProductPage() {
  const pdp = document.querySelector('[data-product-handle]');
  if (!pdp) return;

  const handle = pdp.dataset.productHandle;
  const data   = REVAL_PRODUCTS[handle];

  // ── Scent canvas ──
  const canvas = document.getElementById('rv-pdp-canvas');
  if (canvas) {
    if (data?.scentTheme) {
      initScentCanvas(canvas, data.scentTheme, data.particleColors || [], data.bgColors || []);
    } else {
      // Fallback solid background
      canvas.parentElement.style.background = '#080808';
    }
  }

  // ── Fill metadata (decorative — must never block cart controls below) ──
  if (data) {
    const inspiredByEl = document.getElementById('rv-inspired-by');
    if (inspiredByEl) inspiredByEl.textContent = data.inspiredBy || '';

    const scentProfileEl = document.getElementById('rv-scent-profile');
    if (scentProfileEl) scentProfileEl.textContent = data.scentProfile || '';

    const translitEl = document.getElementById('rv-name-translit');
    if (translitEl) translitEl.textContent = data.nameTranslit || '';

    // ── Scent pyramid ──
    const pyramidEl = document.getElementById('rv-scent-pyramid');
    if (pyramidEl && data.scentNotes) {
      pyramidEl.innerHTML = [
        { label: 'Top',   notes: data.scentNotes.top   },
        { label: 'Heart', notes: data.scentNotes.heart },
        { label: 'Base',  notes: data.scentNotes.base  },
      ].map(({ label, notes }) => `
        <div class="rv-scent-row">
          <span class="rv-scent-row-label">${label}</span>
          <div class="rv-scent-tags">
            ${(notes || []).map((n) => `<span class="rv-scent-tag">${n}</span>`).join('')}
          </div>
        </div>`).join('');
    }

    // ── Tab content ──
    const descEl = document.getElementById('rv-tab-description');
    if (descEl && !descEl.textContent.trim() && data.description) {
      descEl.textContent = data.description;
    }
    const howEl = document.getElementById('rv-tab-how');
    if (howEl) howEl.textContent = data.howToUse || '';
    const ingEl = document.getElementById('rv-tab-ingredients');
    if (ingEl) ingEl.textContent = data.ingredients || '';

    // ── Floating scent notes ──
    const notesFloat = document.getElementById('rv-scent-notes-float');
    if (notesFloat && data.scentNotes) {
      const allNotes = [
        ...( data.scentNotes.top   || []),
        ...( data.scentNotes.heart || []),
        ...( data.scentNotes.base  || []),
      ];
      notesFloat.innerHTML = allNotes.map((n) => `
        <span style="font-size:0.58rem;letter-spacing:0.2em;text-transform:uppercase;color:rgba(250,248,245,0.55);padding:4px 10px;border:1px solid rgba(255,255,255,0.1);background:rgba(0,0,0,0.3);-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px)">
          ${n}
        </span>`).join('');
    }
  }

  // ── Tabs ──
  const tabBtns   = document.querySelectorAll('.rv-tab-btn');
  const tabPanels = document.querySelectorAll('.rv-tab-panel');
  tabBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const tab = btn.dataset.tab;
      tabBtns.forEach((b) => {
        b.classList.remove('active');
        b.setAttribute('aria-selected', 'false');
      });
      tabPanels.forEach((p) => {
        p.classList.remove('active');
        p.setAttribute('aria-hidden', 'true');
      });
      btn.classList.add('active');
      btn.setAttribute('aria-selected', 'true');
      const panel = document.getElementById(`rv-tab-${tab}`);
      if (panel) {
        panel.classList.add('active');
        panel.setAttribute('aria-hidden', 'false');
      }
    });
  });

  // ── Qty ──
  let qty = 1;
  const qtyVal = document.getElementById('rv-qty-val');
  document.getElementById('rv-qty-minus')?.addEventListener('click', () => {
    qty = Math.max(1, qty - 1);
    if (qtyVal) qtyVal.textContent = qty;
  });
  document.getElementById('rv-qty-plus')?.addEventListener('click', () => {
    qty++;
    if (qtyVal) qtyVal.textContent = qty;
  });

  // ── PDP Add to Cart ──
  const atcBtn = document.getElementById('rv-pdp-atc');
  if (atcBtn) {
    atcBtn.addEventListener('click', async () => {
      const variantId = atcBtn.dataset.variantId;
      if (!variantId) return;
      atcBtn.disabled    = true;
      atcBtn.textContent = 'Adding...';
      try {
        await cartAdd(variantId, qty);
        atcBtn.innerHTML = `
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="20 6 9 17 4 12"/>
          </svg>
          Added to Cart`;
        refreshDrawer();
        openDrawer();
        setTimeout(() => {
          atcBtn.textContent = 'Add to Cart';
          atcBtn.disabled    = false;
        }, 2000);
      } catch {
        atcBtn.textContent = 'Add to Cart';
        atcBtn.disabled    = false;
      }
    });
  }

  // ── Gallery thumbnails ──
  const mainImg = document.getElementById('rv-gallery-main');
  document.querySelectorAll('.rv-gallery-thumb').forEach((btn) => {
    btn.addEventListener('click', () => {
      if (mainImg) mainImg.src = btn.dataset.src;
      document.querySelectorAll('.rv-gallery-thumb').forEach((b) => {
        b.style.borderColor = 'rgba(255,255,255,0.2)';
      });
      btn.style.borderColor = 'var(--accent-gold)';
    });
  });
}

// ── Cart page AJAX qty / remove ───────────────────────────────
function initCartPage() {
  if (!document.getElementById('rv-cart-items')) return;

  document.addEventListener('click', async (e) => {
    // Remove button
    const removeBtn = e.target.closest('.rv-cart-remove[data-key]');
    if (removeBtn) {
      await cartChange(removeBtn.dataset.key, 0);
      window.location.reload();
      return;
    }
    // Qty minus
    const minusBtn = e.target.closest('.rv-cart-qty-minus');
    if (minusBtn) {
      const newQty = Math.max(0, Number(minusBtn.dataset.qty));
      await cartChange(minusBtn.dataset.key, newQty);
      window.location.reload();
      return;
    }
    // Qty plus
    const plusBtn = e.target.closest('.rv-cart-qty-plus');
    if (plusBtn) {
      await cartChange(plusBtn.dataset.key, Number(plusBtn.dataset.qty));
      window.location.reload();
    }
  });
}

// ── Boot ──────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {
  initHeader();
  initScrollReveal();
  initCartDrawer();
  initCardATC();
  initCardMeta();
  initCardNotes();
  initHeroCanvas();
  initParallax();
  initProductPage();
  initCartPage();
});
